"use client"

import { ReactNode } from "react"
import { routes } from "src/config/routes"
import { ListProductData } from "src/data/product-list/types"
import { trackProductLinkClick, useTrackViewPromotion } from "src/tracking/events"
import { A, AProps } from "./A"

export type ProductLinkProps = AProps & {
  product: ListProductData
  listId: string
  className?: string
  children: ReactNode
}

export const ProductLink = ({ product, listId, className, children, ...aProps }: ProductLinkProps) => {
  const ref = useTrackViewPromotion(product)

  if (!product.slug) {
    return null
  }

  const href = routes.formatProduct(product.slug)

  return (
    <A
      {...aProps}
      ref={ref}
      title="Ansehen"
      href={href}
      className={className}
      onClick={() => trackProductLinkClick(listId, product)}
    >
      {children}
    </A>
  )
}
